import { FiltersMap } from '@wix/bex-core';
import { NestedCollectionLevelDescriptor } from './NestedCollectionLevelDescriptor';
import { ActionsCell } from '../../components/ActionsCell';
import {
  NestedTableNestColumns,
  RenderMainColumn,
} from './NestedTableNodeState';

export interface NestedTableLevelDescriptor<
  C extends string,
  T,
  F extends FiltersMap,
> extends NestedCollectionLevelDescriptor<T, F> {
  readonly columns?: NestedTableNestColumns<C, T>;
  readonly renderMainColumn?: RenderMainColumn<T>;
  readonly actionsCell?: ActionsCell<T, F>;
  readonly breadcrumbs?: (
    item: T,
  ) => { id: string; name: string }[] | null | undefined;
  readonly onAddNewClick?: () => void;
}
